// Components
import { Flex } from 'yard-utilities/components'

// Styles
import styles from './Menu.module.sass'

interface MenuProps {
  active: boolean
  toggleMenu: () => void
}

const Menu = ({ active, toggleMenu }: MenuProps) => {
  return (
    <Flex
      flexDirection="column"
      rowGap={{ sm: 4 }}
      center
      className={`${styles.menu} ${active ? styles.active : ''}`}
      onClick={toggleMenu}
    >
      <div className={styles.line}></div>
      <div className={styles.line}></div>
      <div className={styles.line}></div>
    </Flex>
  )
}

export default Menu
